<template>
  <div class="consumption-bills">
    <el-form :inline="true" :model="form">
      <el-form-item label="经营者"><el-input v-model="form.managerName" /></el-form-item>
      <el-form-item label="手机号"><el-input v-model="form.managerPhone" /></el-form-item>
      <el-form-item label="房源名称"><el-input v-model="form.roomName" /></el-form-item>
      <el-form-item label="扣除时间">
        <el-date-picker
          v-model="form.searchTimeVal"
          type="datetimerange"
          :unlink-panels="true"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item><el-button @click="search" type="primary">查询</el-button></el-form-item>
    </el-form>
    <el-table v-bind="tableOptions" :data="tableData" ref="table">
      <el-table-column label="订单号" prop="orderCode" width="180px" />
      <el-table-column label="经营者" prop="managerName" />
      <el-table-column label="手机号" prop="managerPhone" width="120px" />
      <el-table-column label="房源名称" prop="roomName" />
      <el-table-column label="扣除金额" prop="deductMoney">
        <template v-slot="scope">
          <span>{{ toFixed(scope.row.deductMoney) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="入住姓名" prop="occupantNames" />
      <el-table-column label="入离时间" width="180px">
        <template #default="scope">
          <div>抵{{ scope.row.actualCheckInTime }}</div>
          <div>离{{ scope.row.actualCheckOutTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="扣除时间" prop="createTime" width="180px" />
    </el-table>
    <RPagination :pagination="pagination" @current-change="handlePageChange" />
  </div>
</template>

<script>
import RPagination from '@/components/common/RPagination'
import { mapActions } from "vuex";
export default {
  name: "ConsumptionBills",
  components: { RPagination },
  data(){
    return {
      pagination: {
        total: 0,
        pageNumber: 1,
        pageSize: 20,
      },
      tableOptions: {
        height: "100%",
      },
      tableData: [],
      form: {
        managerName: "",
        managerPhone: "",
        roomName: "",
        searchTimeVal: "",
      },
    }
  },
  methods: {
    ...mapActions(["fetchData"]),
    toFixed(value){
      return new Number(value).toFixed(2);
    },
    setTableHeight() {
      this.$nextTick(() => setTimeout(() => {
        if (this.$refs.table) {
          const top = this.$refs.table.$el.getBoundingClientRect().top;
          this.tableOptions.height = document.body.clientHeight - top - 60;
        }
      }))
    },
    search(){
      const params = {
        managerName: this.form.managerName, // 经营者名称
        managerPhone: this.form.managerPhone, // 经营者手机号
        roomName: this.form.roomName, // 房源名称
        pageNumber: this.pagination.pageNumber,
        pageSize: this.pagination.pageSize,
      }
      if(this.form.searchTimeVal){
        if(this.form.searchTimeVal[0]){
          params.createDateStart = this.form.searchTimeVal[0];
        }
        if(this.form.searchTimeVal[1]){
          params.createDateEnd = this.form.searchTimeVal[0];
        }
      }
      this.fetchData({
        url: '消费记录',
        method: 'get',
        params,
      }).then(res => {
        this.tableData = res.data;
        this.pagination.total = res.rowCount;
      });
    },
    handlePageChange(index, size) {
      this.pagination.pageNumber = index;
      this.pagination.pageSize = size;
      this.search();
    },
  },
  created(){
    this.search();
  },
  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  },
};
</script>

<style lang="less" scoped>
.consumption-bills {
}
</style>